"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var framer_motion_1 = require("framer-motion");
var styles_1 = require("../styles");
var TabWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n\n  button {\n    ", "\n    padding: ", " ", ";\n    border: 1px solid ", ";\n    font-family: ", ";\n    font-weight: 500;\n    position: relative;\n    z-index: 0;\n\n    &:nth-of-type(1),\n    &:nth-of-type(1) span { border-radius: 20px 0 0 20px; }\n\n    &:nth-of-type(2),\n    &:nth-of-type(2) span { border-radius: 0 20px 20px 0; }\n\n    &:first-child {\n      &:last-child {\n        &, span {\n          border-radius: 20px 20px 20px 20px;\n          pointer-events: none;\n        }\n      }\n    }\n\n    span {\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      top: 0;\n      z-index: -1;\n    }\n  }\n\n  ", "\n"], ["\n  text-align: center;\n\n  button {\n    ", "\n    padding: ", " ", ";\n    border: 1px solid ", ";\n    font-family: ", ";\n    font-weight: 500;\n    position: relative;\n    z-index: 0;\n\n    &:nth-of-type(1),\n    &:nth-of-type(1) span { border-radius: 20px 0 0 20px; }\n\n    &:nth-of-type(2),\n    &:nth-of-type(2) span { border-radius: 0 20px 20px 0; }\n\n    &:first-child {\n      &:last-child {\n        &, span {\n          border-radius: 20px 20px 20px 20px;\n          pointer-events: none;\n        }\n      }\n    }\n\n    span {\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      top: 0;\n      z-index: -1;\n    }\n  }\n\n  ", "\n"])), (0, styles_1.getP12)(), (0, styles_1.getRelative)(8, 'mobile'), (0, styles_1.getRelative)(20, 'mobile'), function (_a) {
    var theme = _a.theme;
    return theme.colors.greenlight;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.basier;
}, styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    button { padding: ", " ", "; }\n  "], ["\n    button { padding: ", " ", "; }\n  "])), (0, styles_1.getRelative)(8, 'desktop'), (0, styles_1.getRelative)(20, 'desktop')));
var tabVariants = {
    inactive: {
        color: '#5F895E',
        transition: __assign({}, (0, styles_1.getTransition)())
    },
    active: {
        color: '#FFF',
        transition: __assign(__assign({}, (0, styles_1.getTransition)()), { delay: .3 })
    }
};
var backgroundColorVariants = {
    0: {
        inactive: {
            width: 0,
            backgroundColor: '#FFF',
            right: '0',
            transition: __assign({}, (0, styles_1.getTransition)())
        },
        active: {
            width: '100%',
            backgroundColor: '#5F895E',
            transition: __assign({}, (0, styles_1.getTransition)())
        }
    },
    1: {
        inactive: {
            width: 0,
            backgroundColor: '#FFF',
            left: '0',
            transition: __assign({}, (0, styles_1.getTransition)())
        },
        active: {
            width: '100%',
            backgroundColor: '#5F895E',
            transition: __assign({}, (0, styles_1.getTransition)())
        }
    }
};
var getTabItems = function (data, currentActive, onClickTab) { return data.map(function (chart, idx) { return ((0, jsx_runtime_1.jsxs)(framer_motion_1.motion.button, __assign({ onClick: function () { return onClickTab(idx); }, variants: tabVariants, exit: 'inactive', animate: idx === currentActive ? 'active' : 'inactive' }, { children: [chart.title, (0, jsx_runtime_1.jsx)(framer_motion_1.motion.span, { variants: backgroundColorVariants[idx], initial: 'inactive', animate: idx === currentActive ? 'active' : 'inactive' })] }), idx)); }); };
exports.Tabs = (0, react_1.memo)(function (_a) {
    var data = _a.data, onClickTab = _a.onClickTab, currentActive = _a.currentActive;
    var TabItems = (0, react_1.useMemo)(function () { return getTabItems(data, currentActive, onClickTab); }, [currentActive]);
    return ((0, jsx_runtime_1.jsx)(TabWrapper, { children: TabItems }));
});
var templateObject_1, templateObject_2;
